import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const SwapHorizIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.35355 14.6464L6.31716 11.6828C6.56914 11.4309 7 11.6093 7 11.9657V14L14 14V16L7 16V18.0343C7 18.3907 6.56914 18.5691 6.31716 18.3172L3.35355 15.3536C3.15829 15.1583 3.15829 14.8417 3.35355 14.6464Z"
          fill="#333333"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.6464 9.35355L17.6828 12.3172C17.4309 12.5691 17 12.3907 17 12.0343L17 10L10 10L10 8L17 8L17 5.96569C17 5.60932 17.4309 5.43086 17.6828 5.68284L20.6464 8.64645C20.8417 8.84171 20.8417 9.15829 20.6464 9.35355Z"
          fill="#333333"
        />
      </svg>
    )
  }
)
